





































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  MANUAL_UPDATE_IPT, MANUAL_UPDATE_IPT_MODAL_ERRORS,
  OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL,
  OPEN_MANUAL_UPDATE_IPT_MODAL,
  SEARCH_EMPLOYEES_CURRENT_FORM, SET_MANUAL_UPDATE_IPT_MODAL_ERRORS,
  SET_OPEN_MANUAL_UPDATE_IPT_MODAL,
  SET_SEARCH_EMPLOYEES_CURRENT_FORM,
} from '@/types/managerForm.types';
import { ManagerForm101Data } from '@/models/manager/ManagerForm101Data.model';

@Component({})
export default class ManualUpdateIptModal extends Vue {

  @Inject() public $validator;

  @Action(MANUAL_UPDATE_IPT, StoreNamespace.MANAGER) public manualUpdateIpt;

  @Mutation(SET_SEARCH_EMPLOYEES_CURRENT_FORM, StoreNamespace.MANAGER) public setSearchEmployeesCurrentForm;
  @Mutation(SET_OPEN_MANUAL_UPDATE_IPT_MODAL, StoreNamespace.MANAGER) public setOpenManualUpdateIptModal;
  @Mutation(SET_MANUAL_UPDATE_IPT_MODAL_ERRORS, StoreNamespace.MANAGER) public setManualUpdateIptModalErrors;

  @Getter(SEARCH_EMPLOYEES_CURRENT_FORM, StoreNamespace.MANAGER)
  public searchEmployeesCurrentForm!: ManagerForm101Data;
  @Getter(OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL, StoreNamespace.MANAGER)
  public openManagerFormResetPasswordModal!: boolean;
  @Getter(OPEN_MANUAL_UPDATE_IPT_MODAL, StoreNamespace.MANAGER) public openManualUpdateIptModal!: boolean;
  @Getter(MANUAL_UPDATE_IPT_MODAL_ERRORS, StoreNamespace.MANAGER) public manualUpdateIptModalErrors!: string[];

  public closeDialog(): void {
    this.setOpenManualUpdateIptModal(false);
  }

  public confirmDialog(): void {
    this.manualUpdateIpt({
      formId: this.searchEmployeesCurrentForm.formId,
      officeNum: this.searchEmployeesCurrentForm.officeNum,
      idNum: this.searchEmployeesCurrentForm.idNum,
      positionNum: this.searchEmployeesCurrentForm.positionNum,
    });
  }

  public destroyed() {
    this.setOpenManualUpdateIptModal(false);
    this.setManualUpdateIptModalErrors([]);
  }

}
